module.exports = __webpack_public_path__ + "static/media/siis_logo.7910b6da.png";